import type { BuiltInDashboardType, ColSpan, DashboardLayout, WidgetId } from './dashboard.types';

const DESKTOP_COL_SPAN: Record<WidgetId, ColSpan> = {
  at_a_glance: 4,
  chosen_yacht: 2,
  needs_attention: 2,
  next_event: 2,
  weather: 2,
  whos_on_board: 2,
  budget: 2,
  our_memories: 2,
  chat: 2,
  projects: 2,
  logs: 2,
  crew_roster: 2,
  invoices_to_pay: 2,
  financial_status: 2,
  spend_by_category: 2,
  maintenance_tasks: 2,
};

const buildLayout = (ids: WidgetId[]): DashboardLayout => ({
  desktop: {
    widgets: ids.map((id, index) => ({
      id,
      visible: true,
      order: index,
      col_span: DESKTOP_COL_SPAN[id],
    })),
  },
  mobile: {
    widgets: ids.map((id, index) => ({
      id,
      visible: true,
      order: index,
      col_span: 1 as ColSpan,
    })),
  },
});

const OWNER_WIDGETS: WidgetId[] = [
  'at_a_glance',
  'chosen_yacht',
  'needs_attention',
  'next_event',
  'weather',
  'whos_on_board',
  'budget',
  'our_memories',
  'chat',
];

const CAPTAIN_WIDGETS: WidgetId[] = OWNER_WIDGETS;

const CREW_WIDGETS: WidgetId[] = [
  'at_a_glance',
  'chosen_yacht',
  'needs_attention',
  'next_event',
  'weather',
  'whos_on_board',
  'chat',
];

const SERVICE_PROVIDER_WIDGETS: WidgetId[] = [
  'at_a_glance',
  'needs_attention',
  'next_event',
  'weather',
  'chat',
];

const GUEST_WIDGETS: WidgetId[] = [
  'at_a_glance',
  'next_event',
  'weather',
  'whos_on_board',
  'our_memories',
  'chat',
];

const NO_ROLE_WIDGETS: WidgetId[] = [
  'at_a_glance',
  'chosen_yacht',
  'needs_attention',
  'next_event',
  'weather',
  'chat',
];

export const DEFAULT_CONFIGS: Record<BuiltInDashboardType, DashboardLayout> = {
  owner: buildLayout(OWNER_WIDGETS),
  captain: buildLayout(CAPTAIN_WIDGETS),
  crew: buildLayout(CREW_WIDGETS),
  service_provider: buildLayout(SERVICE_PROVIDER_WIDGETS),
  guest: buildLayout(GUEST_WIDGETS),
  no_role: buildLayout(NO_ROLE_WIDGETS),
};

export function getDefaultLayout(type: string): DashboardLayout {
  return DEFAULT_CONFIGS[type as BuiltInDashboardType] ?? DEFAULT_CONFIGS['no_role'];
}
